import BaseReportController from '../reports/baseReportController';
import { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';

class LeadMonitorController extends BaseReportController {
  constructor(authService, reportingService, userService, enums, loadingService, $scope, utilsService, leadMonitorService, $stateParams, $q) {
    "ngInject";

    super(reportingService, loadingService, utilsService);

    if(!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.reportingService = reportingService;
    this.userService = userService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.$scope = $scope;
    this.utilsService = utilsService;
    this.leadMonitorService = leadMonitorService;
    this.$stateParams = $stateParams;

    this.reportCriteria = {};
    this.dtPopups = {};
    this.errMsgs = [];
    
    this.panels = {
      reportCriteria: true,
      reportData: false
    };

    this.enquiriesBySource = null;
    this.enquiriesByReason = null;
    this.enquiriesByBrand = null;
    this.enquiriesByModel = null;
    this.enquiriesExpenditure = null;

    this.selectedSource = null;
    this.selectedSourceName = null;
    this.selectedProvider = null;
    this.selectedCustomSource = null;    
    this.selectedReason = null;
    this.selectedReasonName = null;
    this.selectedBrandId = null;    
    this.selectedBrandName = null;

    this.reasonTitle = null;
    this.brandTitle = null;
    this.modelTitle = null;    

    this.$scope.$on('leadMonitor:selectionChanged', this.selectionChanged.bind(this));

    this.dataSources = [
      {id: 1, name: 'Leads'},
      {id: 2, name: 'Enquiries'}
    ];

    this.getUserLocations();
    this.getDateRangeList();
    this.reset()
      .then(response => {
        this.viewAnalytics();    
      });    
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  getDateRangeList() {
    this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
  }

  getUserLocations() {
    this.userLocations = this.authService.authData.userLocations.map(l => {
      return {id: l.key, name: l.value};
    });

    this.userLocations.unshift({id: null, name: 'All'})
  }

  showDatePopup(fieldName) {
    this.dtPopups[fieldName] = true;
  }

  reset() {    
    this.errMsgs = [];
    const dataSource = _find(this.dataSources, o => o.id === this.$stateParams.dataSource);
    const dateRange = _find(this.dateRangeList, o => o.id === this.$stateParams.dateRange);

    this.reportCriteria.dateRangeOption = dateRange || this.dateRangeList[0];
    this.reportCriteria.startDate = new Date();
    this.reportCriteria.endDate = new Date();
    this.reportCriteria.location = this.userLocations[0];
    this.reportCriteria.dataSource = dataSource || this.dataSources[0];

    this.resetSelection();

    return this.updateDateRange();
  }

  resetSelection() {
    this.reasonTitle = 'Enquiries by Reason';
    this.brandTitle = 'Enquiries by Brand';
    this.modelTitle = 'Enquiries by Model';

    this.selectedSource = null;
    this.selectedSourceName = null;
    this.selectedProvider = null;
    this.selectedCustomSource = null;    
    this.selectedReason = null;
    this.selectedReasonName = null;
    this.selectedBrandId = null;    
    this.selectedBrandName = null;
  }

  viewAnalytics() {
    this.panels.reportData = true;

    if (!this.validateCriteria()) {
      return;
    }

    const parsedCriteria = this.parseCriteria();

    let src1, src2, src3, src4, src5;

    if (this.forWebEnquiry()) {
      src1 = this.leadMonitorService.getWebEnquiriesBySource(parsedCriteria);
      src2 = this.leadMonitorService.getWebEnquiriesByReason(parsedCriteria);
      src3 = this.leadMonitorService.getWebEnquiriesByBrands(parsedCriteria);
      src4 = this.leadMonitorService.getWebEnquiriesByModel(parsedCriteria);
      src5 = this.leadMonitorService.getWebEnquiriesExpenditure(parsedCriteria);
    }
    else {
      src1 = this.leadMonitorService.getEnquiriesBySource(parsedCriteria);
      src2 = this.leadMonitorService.getEnquiriesByOrigination(parsedCriteria);
      src3 = this.leadMonitorService.getEnquiriesByBrand(parsedCriteria);
      src4 = this.leadMonitorService.getEnquiriesByModel(parsedCriteria);
      src5 = this.leadMonitorService.getEnquiriesExpenditure(parsedCriteria);
    }

    src1.then(response => { this.enquiriesBySource = response.data; });
    src2.then(response => { this.enquiriesByReason = response.data; });
    src3.then(response => { this.enquiriesByBrand = response.data; });
    src4.then(response => { this.enquiriesByModel = response.data; });
    src5.then(response => { this.enquiriesExpenditure = response.data; });              
  }

  validateCriteria() {
    this.errMsgs = [];

    if (!this.reportCriteria.startDate) {
      this.errMsgs.push('Please provide a Start Date');
    }

    if (!this.reportCriteria.endDate) {
      this.errMsgs.push('Please provide an End Date');
    }

    if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
      this.errMsgs.push('Start Date can not be greater than End Date');
    }

    return this.errMsgs.length === 0;
  }

  parseCriteria() {
    let parsedCriteria = {};

    this.parseStartAndEndDate(parsedCriteria);
    
    parsedCriteria.locationIds = this.getLocationIds();
    parsedCriteria.additionalParameter1 = this.selectedSource;
    parsedCriteria.additionalParameter2 = this.selectedProvider;
    parsedCriteria.additionalParameter3 = this.selectedCustomSource;    
    parsedCriteria.additionalParameter4 = this.selectedReason;
    parsedCriteria.brandId = this.selectedBrandId;
    return parsedCriteria;
  }

  getLocationIds() {
    let locationIds;

    if (!this.reportCriteria.location.id) {
      locationIds = _filter(this.userLocations, o => o.id).map(ul => ul.id);
    }
    else {
      locationIds = [this.reportCriteria.location.id];
    }

    return locationIds;
  }

  selectionChanged(e, data) {
    if (data.event === 'sourceSelected'){
      if (this.forWebEnquiry()) {
        this.selectedSource = this.addUpdateParameter(this.selectedSource, data.identifiers.sourceType);  
      }
      else {
        this.selectedSource = this.addUpdateParameter(this.selectedSource, data.identifiers.id);
      }
      
      this.selectedProvider = this.addUpdateParameter(this.selectedProvider, data.identifiers.providerType);
      this.selectedCustomSource = this.addUpdateParameter(this.selectedCustomSource, data.identifiers.customSource);
      this.selectedReason = null;
      this.selectedBrandId = null;

      this.selectedSourceName = this.addUpdateParameter(this.selectedSourceName, data.name);

      this.reasonTitle = this.titleBuilder('Enquiries by Reason', [{category:'Source', name: this.selectedSourceName}]);

      this.updateReasons();
    }
    else if (data.event === 'reasonSelected'){
      if (this.forWebEnquiry()) {
        this.selectedReason = this.addUpdateParameter(this.selectedReason, data.identifiers.identifier);
      }
      else {
        this.selectedReason = this.addUpdateParameter(this.selectedReason, data.identifiers.id);
      }            
      this.selectedBrandId = null;      

      this.selectedReasonName = this.addUpdateParameter(this.selectedReasonName, data.name);

      this.brandTitle = this.titleBuilder('Enquiries by Brand', [
        {category:'Source', name: this.selectedSourceName},
        {category:'Reason', name: this.selectedReasonName},
      ]);

      this.updateBrands();
    }    

    else if (data.event === 'brandSelected'){
      if (this.forWebEnquiry()) {
        this.selectedBrandId = this.addUpdateParameter(this.selectedBrandId, data.identifiers.identifier);
      }
      else {
        this.selectedBrandId = this.addUpdateParameter(this.selectedBrandId, data.identifiers.id);
      }                  
      
      this.selectedBrandName = this.addUpdateParameter(this.selectedBrandName, data.name);

      this.modelTitle = this.titleBuilder('Enquiries by Model', [
        {category:'Source', name: this.selectedSourceName},
        {category:'Reason', name: this.selectedReasonName},
        {category:'Brand', name: this.selectedBrandName},
      ]);      

      this.updateModels();
    }  
  }

  updateReasons() {
    let src;
    if (this.forWebEnquiry()) {
      src = this.leadMonitorService.getWebEnquiriesByReason(this.parseCriteria());
    }
    else {
      src = this.leadMonitorService.getEnquiriesByOrigination(this.parseCriteria());
    }    

    src.then(response => { this.enquiriesByReason = response.data; });
    
    this.updateBrands();
  }  

  updateBrands(){
    let src;
    if (this.forWebEnquiry()) {
      src = this.leadMonitorService.getWebEnquiriesByBrands(this.parseCriteria());
    }
    else {
      src = this.leadMonitorService.getEnquiriesByBrand(this.parseCriteria());
    }        

    src.then(response => { this.enquiriesByBrand = response.data; });
    
    this.updateModels();
  }  

  updateModels(){
    let src;
    if (this.forWebEnquiry()) {
      src = this.leadMonitorService.getWebEnquiriesByModel(this.parseCriteria());
    }
    else {
      src = this.leadMonitorService.getEnquiriesByModel(this.parseCriteria());
    }             

    src.then(response => { this.enquiriesByModel = response.data; });
  }    

  addUpdateParameter(currentValue, newValue){
    if (currentValue === newValue) {
      return null;
    }
    
    return newValue;
  }

  titleBuilder(base, params) {
    let title = base;

    params.map(p => {
      if (p.name) {
        title += ` ${p.category} ${p.name},`;  
      }      
    });

    return base;
  }

  forWebEnquiry() {
    return this.reportCriteria.dataSource.id === 1;
  }
}

export default LeadMonitorController;


// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/leadMonitor.controller.js